export const toSentenceCase = str => str[0].toUpperCase() + str.substr(1)
